var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contents4" }, [
    _c("img", { staticClass: "bg", attrs: { src: _vm.bgImg } }),
    _vm._v(" "),
    _c("div", { staticClass: "contents" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("p", { staticClass: "text2" }, [
        _vm._v("\n      3년 이상의 정비경력을 보유한 "),
        _vm.isMobile ? _c("br") : _vm._e(),
        _vm._v("전문 정비사가"),
        !_vm.isMobile ? _c("br") : _vm._e(),
        _vm._v("\n      고객님이 요청한 장소에 "),
        _vm.isMobile ? _c("br") : _vm._e(),
        _vm._v("직접 찾아갑니다."),
        !_vm.isMobile ? _c("br") : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", { staticClass: "text1" }, [
      _vm._v("\n      정비사 실명제"),
      _c("br"),
      _vm._v("\n      카수리에"),
      _c("br"),
      _vm._v("\n      안심하고 맡겨주세요!"),
      _c("br")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-33fcf6ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-33fcf6ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents/main/Contents4.vue
// module id = null
// module chunks = 